'use client'

import { Slot } from 'primitives/slot'

import { Button } from './button'

export function ScrollToElementId({
  children,
  elementId,
  asChild,
  ...props
}: {
  children: React.ReactNode
  elementId: string
  asChild?: boolean
} & React.ComponentProps<typeof Button> &
  React.HTMLAttributes<HTMLButtonElement>) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()
    const section = document.querySelector(`#${elementId}`)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const Element = asChild ? Slot : Button

  return (
    <Element {...props} onClick={handleClick}>
      {children}
    </Element>
  )
}
